export enum COLUMNS {
    name = 'Name',
    vImageUrl = 'Main Image',
    thumbnailUrl = 'Thumbnail',
    vAdditionalImages = 'Additional Images',
    count = 'Count',
    minBid = 'Min Bid',
    bidIncrement = 'Bid Increment',
    valueProvided = 'Value Provided',
    buyItNowOnlyItem = 'Buy it Now Only Item',
    buyItNowEnabled = 'Buy it Now Enabled',
    buyItNowAmount = 'Buy it Now Amount',
    collectSalesTax = 'Collect Sales Tax',
    salesTax = 'Sales Tax',
    displayDonatedBy = 'Display Donated By',
    donatedByName = 'Donated By',
    categories = 'Categories',
    desc = 'Description',
    summary = 'Summary',
    additionalInfoRequired = 'Any additional info required',
    additionalInfoDesc = 'Addtional info description',
    additionalInfo = 'Instructions for additional info',
    additionalInfoSelectRequired = 'Any additional info, to be selected by user',
    additionalInfoSelectDesc = 'Additional info select description',
    additionalInfoSelect = 'Options to be selected',

    minQuantity = 'Min Quantity',
    allowedQuantity = 'Max Quantity',
    amount = 'Amount',
    enforceInventory = 'Enforce Inventory',
    inventory = 'Inventory',
    hideInventory = 'Hide Inventory',
    optionStartDate = 'Start Date/Time',
    optionEndDate = 'End Date/Time',
    hostName = 'Host Name',
    hostEmail = 'Host Email',
    notifyHost = 'Notify Host',
    displayHostInfo = 'Display Host',
    eventDetailLink = 'Event Detail Link',
    startDateTimeGmtUnix = 'Event Date/Time',
    duration = 'Duration in minutes',
    vEventVenueName = 'Venue Name',
    vEventVenueAddress = 'Address',
    vEventVenueUnitNum = 'Unit Num',

    shoppingForm_name = 'Form Data Name',
    shoppingForm_type = 'Form Data Type',
    shoppingForm_options = 'Form Data Options',
}

export const AuctionItemSheetColumns = [
    { header: 'Item Name (127 Charcter Max)', key: 'name' },
    { header: 'Name', key: 'name' },
    { header: 'Image (File Name Or URL)', key: 'vImageUrl' },
    { header: 'Image (File Name, or URL)', key: 'vImageUrl' }, // live - old
    { header: 'Image Url', key: 'vImageUrl' },
    { header: 'Additional Images (File name or URL, Comma seperated)', key: 'vAdditionalImages' },
    { header: 'Additional Images, File name or URL (comma seperated)', key: 'vAdditionalImages' }, // live - old
    { header: 'Additional Images', key: 'vAdditionalImages' },
    { header: 'Thumbnail', key: 'thumbnailUrl' },
    { header: 'Total Item Count', key: 'count' },
    { header: 'Count', key: 'count' },
    { header: 'Min Bid', key: 'minBid' },
    { header: 'Bid Increment', key: 'bidIncrement' },
    { header: 'Value of goods or services provided, if any!', key: 'valueProvided' },
    { header: 'Value provided', key: 'valueProvided' },
    { header: 'Buy It Now Only item (yes/no), buy it now price must be be set if yes.', key: 'buyItNowOnlyItem' },
    { header: 'Buy It Now Only Item', key: 'buyItNowOnlyItem'},
    { header: 'Enable Buy it Now (yes,no)', key: 'buyItNowEnabled' },
    { header: 'Buy It Now Enabled', key: 'buyItNowEnabled'},
    { header: 'Buy it Now Amount', key: 'buyItNowAmount' },
    { header: 'Buy It Now Amount', key: 'buyItNowAmount' },
    { header: 'Collect sales tax for this item(yes/no)', key: 'collectSalesTax' },
    { header: 'Collect Sales Tax', key: 'collectSalesTax'},
    { header: 'Percentage Sales Tax', key: 'salesTax' },
    { header: 'Sales Tax', key: 'salesTax', style: { numFmt: '$#,##0.00' }},
    { header: 'Categories (comma seperated)', key: 'categories' },
    { header: 'Categories', key: 'categories'},
    { header: 'Description (2048 characters max)', key: 'desc' },
    { header: 'Description', key: 'desc'},
    { header: 'Summary (128 characters max)', key: 'summary'},
    { header: 'Memo (2048 characters max)', key: 'memo' },
    { header: 'Memo', key: 'memo'},
    { header: 'Featured (True / False)', key: 'featured' },
    { header: 'Featured', key: 'featured'},
    { header: 'Donated By Name (64 Charcter Max)', key: 'donatedByName' },
    { header: 'Donated By Name', key: 'donatedByName'},
    { header: 'Display Donated By (True / False)', key: 'displayDonatedBy' },
    { header: 'Display Donated By', key: 'displayDonatedBy'},
    { header: 'Item Code (32 Charcter Max)', key: 'itemCode' },
    { header: 'Item Code', key: 'itemCode'},
    { header: 'Display To Donors (True / False)', key: 'displayToDonors' },
    { header: 'Display To Donors', key: 'displayToDonors'},
    { header: 'Add Video (True / False)', key: 'addVideo' },
    { header: 'Add Video', key: 'addVideo'},
    { header: 'Video Provider(1- YouTube, 2-Vimeo, 3- facebook, 0 - other)', key: 'videoProvider' },
    { header: 'Video Provider', key: 'videoProvider'},
    { header: 'Video Url (128 Charcter Max)', key: 'videoUrl' },
    { header: 'Video Url', key: 'videoUrl'},
    { header: 'Any additional info required (yes/no)', key: 'additionalInfoRequired' },
    { header: 'Addtional info description', key: 'additionalInfoDesc' },
    { header: 'Instructions for additional info', key: 'additionalInfoDetail' },
    { header: 'Any additional info, to be selected by user (yes/no)', key: 'additionalInfoSelectRequired' },
    { header: 'Additional info select description', key: 'additionalInfoSelectDesc' },
    { header: 'Options to be selected (comma seperated)', key: 'additionalInfoSelect' },
]

export const PartySignupItemSheetColumns = [
    { header: 'Item Name (127 Charcter Max)', key: 'name' },
    { header: 'Name', key: 'name' },
    { header: 'Images (File name or URL, Comma seperated)', key: 'vImageUrls' },
    { header: 'Thumbnail', key: 'thumbnailUrl' },
    { header: 'Min Qty', key: 'minQuantity' },
    { header: 'Max Qty', key: 'allowedQuantity'},
    { header: 'Amount', key: 'amount'},
    { header: 'Value of goods or services provided, if any!', key: 'valueProvided' },
    { header: 'Value provided', key: 'valueProvided' },
    { header: 'Enforce item inventory for this option (yes/no), inventory count must be be set if yes.', key: 'enforceInventory' },
    { header: 'Inventory Count', key: 'inventory'},
    { header: 'Hide item inventory for this option (yes/no)', key: 'hideInventory'},
    { header: 'Send electronic tickets (yes/no), set QR code flag if yes', key: 'sendTicket'},
    { header: `Don't include QR codes in electronic ticket (yes/no)`, key: 'noQrCodeInEmail'},
    { header: `Display current ticket holders`, key: 'showTicketHolders'},
    { header: 'Start Date/Time', key: 'optionStartDate'},
    { header: 'End Date/Time', key: 'optionEndDate'},
    { header: 'Host Name', key: 'hostName'},
    { header: 'Host Email', key: 'hostEmail'},
    { header: 'Notify Host (yes/no)', key: 'notifyHost'},
    { header: 'Notify Host (yes/no)', key: 'notifyHost'},
    { header: 'Display host information to buyers (yes/no)', key: 'displayHostInfo'},
    { header: 'Event detail link', key: 'eventDetailLink'},
    { header: 'Event Date/Time', key: 'startDateTimeGmtUnix'},
    { header: 'Duration in minutes', key: 'duration'},
    { header: 'Venue Name', key: 'vEventVenueName'},
    { header: 'Address', key: 'vEventVenueAddress'},
    { header: 'Unit Num (Optional)', key: 'vEventVenueUnitNum'},
    { header: 'Description (2048 characters max)', key: 'desc'},
    { header: 'Summary (128 characters max)', key: 'summary'},
    { header: /Form Data Name ([0-9]+)/, key: 'name', formData: true},
    { header: /Form Data Type ([0-9]+)/, key: 'type', formData: true},
    { header: /Form Data Values \(if Type Selection\) ([0-9]+)/, key: 'options', formData: true},
    { header: /Form Data Required ([0-9]+)/, key: 'required', formData: true},
    { header: /Form Data Added Only by Admin \(not shown to the buyers\) ([0-9]+)/, key: 'toBeAddedBy', formData: true},
    { header: /Form Data Description ([0-9]+)/, key: 'desc', formData: true},
]
